import { Fragment } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'

import Button from 'Design/components/Button'
import FormControl from 'Design/components/FormControl'
import FormErrorText from 'Design/components/FormErrorText'
import Heading from 'Design/components/Heading'
import HelpText from 'Design/components/HelpText'
import Input from 'Design/components/Input'
import Label from 'Design/components/Label'

import { useAppDetailContext } from '../../AppDetailContext'
import happyfoxChatFormValidationSchema from './happyfox-chat-auth-form-validation-schema'

import { useInstallMutation } from './happyfox-chat.service'

const ChatAuthForm = (props) => {
  const { onCancel } = props
  const [install, installResult] = useInstallMutation()
  const { name } = useAppDetailContext()
  const navigate = useNavigate()

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty, isSubmitting }
  } = useForm({
    defaultValues: {
      apiKey: ''
    },
    mode: 'onChange',
    resolver: yupResolver(happyfoxChatFormValidationSchema)
  })

  const handleConnect = (data) => {
    const payload = {
      api_key: data.apiKey
    }

    const promise = install(payload).unwrap()

    toast.promise(promise, {
      loading: `Connecting ${name}`,
      success: `Successfully connected ${name}`,
      error: `Unable to connect to your ${name} account. Review your API key and try again`
    })

    promise.then(
      (value) => {
        value && navigate('*')
      },
      (reason) => {
        reason && toast.error(reason.data.message)
      }
    )
  }

  const disableSubmitButton = isSubmitting || !isDirty || installResult.isLoading

  return (
    <Fragment>
      <Heading level={2}>Connect to {name}</Heading>
      <form onSubmit={handleSubmit(handleConnect)}>
        <FormControl isInvalid={errors.apiKey}>
          <Label>API Key</Label>
          <Input {...register('apiKey')} />
          <HelpText>
            You can get/create your API key from the REST API section under 'Apps {'>'} Goodies' in your HappyFox Chat
            account.
          </HelpText>
          {errors.apiKey && <FormErrorText>{errors.apiKey.message}</FormErrorText>}
        </FormControl>
        <Button variant='primary' type='submit' disabled={disableSubmitButton}>
          Connect
        </Button>
        <Button variant='link-muted' onClick={onCancel}>
          Cancel
        </Button>
      </form>
    </Fragment>
  )
}

export default ChatAuthForm
